var map = {
	"./BatteryCar.png": "eeb9",
	"./BigTruck.png": "5b88",
	"./Bus.png": "a53b",
	"./BusinessCar.png": "e100",
	"./Car.png": "a3b0",
	"./MiniBus.png": "5ddd",
	"./MiniTruck.png": "706d",
	"./SUV.png": "5d8a",
	"./Van.png": "bdf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88b2";